import { MicRounded } from '@mui/icons-material';
import { InsertPhotoRounded } from '@mui/icons-material';
import { SmartDisplayRounded } from '@mui/icons-material';
import { HeadphonesRounded } from '@mui/icons-material';
import {
    AccountBalanceWalletRounded,
    BookOutlined,
    BookRounded,
    BorderColorRounded,
    EscalatorWarningRounded,
    EventOutlined,
    ExitToAppRounded,
    FavoriteOutlined,
    FileCopyOutlined,
    FolderOutlined,
    HelpOutlined,
    InfoOutlined,
    JoinInnerRounded,
    LockOutlined,
    MarkChatUnreadRounded,
    MessageOutlined,
    NotesRounded,
    NotificationsOutlined,
    NotificationsRounded,
    PersonRounded,
    PrivacyTipRounded,
    QuizRounded,
    RateReviewRounded,
    SettingsBrightnessRounded,
    SettingsOutlined,
    SettingsRounded,
    ShareOutlined,
    ShareRounded,
    ShoppingBasketOutlined,
    StarRateOutlined,
    TimelapseOutlined,
    TrendingUp,
    YouTube,
} from '@mui/icons-material';
import imgAppointments from '../../assets/appointment.jpeg';
import imgBible from '../../assets/bible.jpeg';
import imgBookings from '../../assets/booking.jpeg';
import svgBooking from '../../assets/booking.svg';
import svgCard from '../../assets/card.svg';
import logo from '../../assets/church.svg';
import imgDevotion from '../../assets/devotion.jpg';
import imgEvents from '../../assets/event.jpeg';
import imgLivestream from '../../assets/livestream.jpeg';
import imgMessage from '../../assets/message.jpeg';
import imgMessages from '../../assets/messages.jpg';
import svgMessaging from '../../assets/messaging.svg';
import imgMinistries from '../../assets/ministries.jpg';
import imgPastor from '../../assets/pastor.jpg';
import imgServices from '../../assets/service.jpeg';
import imgTithes from '../../assets/tithe.jpeg';
import Iconify from '../../components/fragments/Iconify';
import { appUpdateVersion } from '../../utils/config';

export const daysOfWeek = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];

export const guestProfileSettings = [
    {
        subheader: 'Account',
        items: [
            {
                title: 'My Information',
                icon: <PersonRounded />,
                link: '/information',
            },
            {
                title: 'My Wallet',
                icon: <AccountBalanceWalletRounded />,
                link: '/wallet',
            },
            {
                title: 'Notifications',
                icon: <NotificationsRounded />,
                link: '/guest-notifications',
            },
        ],
    },
    {
        subheader: 'Preferences',
        items: [
            {
                title: 'Push Notifications',
                icon: <MarkChatUnreadRounded />,
                link: '/notification-settings',
            },
            {
                id: 'theme',
                title: 'Dark Mode',
                icon: <SettingsBrightnessRounded />,
            },
        ],
    },
    {
        subheader: 'Support',
        items: [
            {
                title: 'Report a Problem',
                icon: <BorderColorRounded />,
                link: '/help',
            },
            {
                id: 'faq',
                title: 'FAQs',
                icon: <QuizRounded />,
            },
            {
                id: 'play',
                title: 'Rate myKanisa',
                icon: <RateReviewRounded />,
            },
            {
                id: 'play',
                title: 'Share myKanisa',
                icon: <ShareRounded />,
            },
        ],
    },
    {
        subheader: 'About',
        items: [
            {
                title: 'Terms and Conditions',
                icon: <InfoOutlined />,
                link: '/terms',
            },
            {
                title: 'Privacy Policy',
                icon: <PrivacyTipRounded />,
                link: '/privacy',
            },
            {
                title: 'Service Charter',
                icon: <JoinInnerRounded />,
                link: '/promise',
            },
        ],
    },
    {
        subheader: 'Auth',
        items: [
            {
                title: 'Logout',
                icon: <InfoOutlined />,
                link: '/logout',
            },
        ],
    },
];

export const guestProfileActivities = [
    {
        name: 'My Bible',
        icon: <MessageOutlined color="primary" />,
        link: '/bible',
        img: imgBible,
    },
    {
        name: 'My Pastors',
        icon: <MessageOutlined color="primary" />,
        link: '/pastors',
        img: imgPastor,
    },
    {
        name: 'My Messages',
        icon: <MessageOutlined color="primary" />,
        link: '/chat',
        img: imgMessages,
        full: true,
    },
];

export const activities = [
    {
        name: 'My Bible',
        icon: <MessageOutlined color="primary" />,
        link: '/bible',
        img: imgBible,
    },
    {
        name: 'Livestreams',
        icon: <YouTube color="primary" />,
        link: '/livestream',
        img: imgLivestream,
    },
    {
        name: 'Ministries',
        icon: <BookOutlined color="primary" />,
        link: '/ministries',
        img: imgMinistries,
    },
    {
        name: 'Devotions',
        icon: <BookOutlined color="primary" />,
        link: '/devotions',
        img: imgDevotion,
    },
    {
        name: 'Events',
        icon: <EventOutlined color="primary" />,
        link: '/events',
        img: imgEvents,
    },
    {
        name: 'Give Contribution',
        icon: <ShoppingBasketOutlined color="primary" />,
        link: '/contribution',
        img: imgTithes,
    },
    {
        name: 'Appointment Sessions',
        icon: <TimelapseOutlined color="primary" />,
        link: '/appointments',
        img: imgAppointments,
    },
    {
        name: 'Service Seats',
        icon: <SettingsOutlined color="primary" />,
        link: '/services',
        img: imgServices,
    },
    {
        name: 'Send Message',
        icon: <BookOutlined color="primary" />,
        link: '/msg',
        img: imgMessage,
    },
    {
        name: 'My Bookings',
        icon: <FileCopyOutlined color="primary" />,
        link: '/bookings',
        img: imgBookings,
    },
];

export const events = [
    {
        name: 'Morning Session',
        venue: 'Main Church',
        desc: 'Lorem ipsum dolor sit amet.',
        date: 'Feb 20, 2021',
        time: '8:30 AM',
        seats: '5',
        spaces: '10',
        booked: '5',
        bookCategory: 'Service',
    },
    {
        name: 'Afternoon Session',
        venue: 'Evangelist Office',
        desc: 'Lorem ipsum dolor sit amet constrecteur narino alit deposot.',
        date: 'Feb 20, 2021',
        time: '2:45 PM',
        seats: '4',
        spaces: '6',
        booked: '1',
        bookCategory: 'Appointment',
    },
    {
        name: 'Evening Session',
        venue: 'Great Hall',
        desc: 'Lorem ipsum dolor sit amet.',
        date: 'Feb 20, 2021',
        time: '7:30 PM',
        seats: '8',
        spaces: '5',
        booked: '6',
        bookCategory: 'Service',
    },
];

export const helpActions = [
    {
        name: 'Share The App',
        desc: 'Tell friends and family about this app',
        icon: <ShareOutlined color="primary" />,
        link: 'https://play.google.com/store/apps/details?id=com.morfie.kanisa',
        full: true,
        share: true,
        blank: true,
    },
    {
        name: 'Rate The App',
        desc: 'Rate and leave a review on playstore',
        icon: <StarRateOutlined color="primary" />,
        link: 'https://play.google.com/store/apps/details?id=com.morfie.kanisa',
        full: true,
        blank: true,
    },
];

export const familyActions = [
    {
        name: 'My Spouse',
        icon: <PersonRounded color="primary" />,
        link: '/spouse',
        full: true,
    },
    {
        name: 'My Children',
        icon: <EscalatorWarningRounded color="primary" />,
        link: '/children',
        full: true,
    },
];

export const profileActions = [
    {
        name: 'My Family',
        icon: <EscalatorWarningRounded color="primary" />,
        link: '/family',
        full: true,
    },
    {
        name: 'Contribution Statement',
        icon: <TrendingUp color="primary" />,
        link: '/contribution-statement',
        full: true,
    },
    {
        name: 'Settings',
        icon: <SettingsRounded color="primary" />,
        link: '/settings',
        full: true,
    },
    {
        name: 'Notification Preferences',
        icon: <NotificationsOutlined color="primary" />,
        link: '/notification-settings',
        full: true,
    },
    {
        name: 'Change Password',
        icon: <LockOutlined color="primary" />,
        link: '/change-password',
        full: true,
    },
    {
        name: 'Help',
        icon: <HelpOutlined color="primary" />,
        link: '/help',
        full: true,
    },
    {
        name: 'About myKanisa',
        icon: <InfoOutlined color="primary" />,
        link: '/about',
        full: true,
    },
    {
        name: 'Logout',
        icon: <ExitToAppRounded color="primary" />,
        link: '/logout',
        full: true,
    },
];

export const aboutActions = [
    {
        name: 'Privacy Policy',
        icon: <FolderOutlined color="primary" />,
        link: '/privacy',
        full: true,
    },
    {
        name: 'Terms and Conditions',
        icon: <InfoOutlined color="primary" />,
        link: '/terms',
        full: true,
    },
    {
        name: 'Our Promise To You',
        icon: <FavoriteOutlined color="primary" />,
        link: '/promise',
        full: true,
    },
];

export const onboard = [
    {
        title: `myKanisa App v${appUpdateVersion.slice(1)}`,
        desc: 'Your one stop Church companion.',
        desc2: '(Product of Morfie Limited)',
        image: logo,
        id: 0,
    },
    {
        title: 'Reserve',
        desc: 'Book seats and space in your church services and appointments respectively.',
        image: svgBooking,
        id: 1,
    },
    {
        title: 'Connect',
        desc: 'Message your church directly, livestream services, make contributions and view church events & announcements.',
        image: svgMessaging,
        id: 2,
    },
    {
        title: 'Generate',
        desc: 'Generate your own church ID and ease church ushering services',
        image: svgCard,
        id: 3,
    },
];

export const churchMinistries = [
    { title: 'Youth', path: '/youth' },
    { title: 'Praise and Worship', path: '/praise' },
    { title: 'Choir', path: '/choir' },
    { title: 'Ushering', path: '/ushering' },
];

export const bibleFABActionButtons = [
    {
        path: '/bible-tools/notepad',
        label: 'Notepad',
        icon: <NotesRounded />,
    },
    {
        path: '/bible-tools/study-reminder',
        label: 'Study Reminder',
        icon: <BookRounded />,
    },
];

export const ministerFABActionButtons = [
    {
        path: '/om/post',
        label: 'Post',
        icon: <InsertPhotoRounded />,
    },
    {
        path: '/om/crusade',
        label: 'Crusade',
        icon: <MicRounded />,
    },
    {
        path: '/om/devotion',
        label: 'Devotion',
        icon: <HeadphonesRounded />,
    },
    {
        path: '/om/service',
        label: 'Service',
        icon: <SmartDisplayRounded />,
    },
];

export const bottomTabs = [
    {
        id: 0,
        label: 'Home',
        iconActive: (
            <Iconify
                sx={{ width: 24, height: 24 }}
                icon="fluent:home-28-filled"
            />
        ),
        iconInactive: (
            <Iconify
                sx={{ width: 24, height: 24 }}
                icon="fluent:home-28-regular"
            />
        ),
        link: '/',
    },
    {
        id: 1,
        label: 'Feed',
        iconActive: (
            <Iconify
                sx={{ width: 24, height: 24 }}
                icon="fluent:broad-activity-feed-16-filled"
            />
        ),
        iconInactive: (
            <Iconify
                sx={{ width: 24, height: 24 }}
                icon="fluent:broad-activity-feed-16-regular"
            />
        ),
        link: '/feed',
    },
    {
        id: 2,
        label: 'Discover',
        iconActive: (
            <Iconify
                sx={{ width: 24, height: 24 }}
                icon="fluent:gift-card-24-filled"
            />
        ),
        iconInactive: (
            <Iconify
                sx={{ width: 24, height: 24 }}
                icon="fluent:gift-card-24-regular"
            />
        ),
        link: '/discover',
    },
    {
        id: 3,
        label: 'Profile',
        iconActive: (
            <Iconify sx={{ width: 24, height: 24 }} icon="ep:user-filled" />
        ),
        iconInactive: <Iconify sx={{ width: 24, height: 24 }} icon="ep:user" />,
        link: '/profile',
    },
];

export const bottomExternalTabs = [
    {
        id: 0,
        label: 'Home',
        iconActive: (
            <Iconify
                sx={{ width: 24, height: 24 }}
                icon="fluent:home-28-filled"
            />
        ),
        iconInactive: (
            <Iconify
                sx={{ width: 24, height: 24 }}
                icon="fluent:home-28-regular"
            />
        ),
        link: '/guest-feed',
    },
    {
        id: 1,
        label: 'Crusade',
        iconActive: (
            <Iconify
                sx={{ width: 24, height: 24 }}
                icon="ant-design:audio-filled"
            />
        ),
        iconInactive: (
            <Iconify
                sx={{ width: 24, height: 24 }}
                icon="ant-design:audio-outlined"
            />
        ),
        link: '/crusade',
    },
    {
        id: 2,
        label: 'Find',
        iconActive: (
            <Iconify sx={{ width: 24, height: 24 }} icon="bxs:location-plus" />
        ),
        iconInactive: (
            <Iconify sx={{ width: 24, height: 24 }} icon="bx:location-plus" />
        ),
        link: '/find',
    },
    {
        id: 3,
        label: 'Profile',
        iconActive: (
            <Iconify sx={{ width: 24, height: 24 }} icon="ep:user-filled" />
        ),
        iconInactive: <Iconify sx={{ width: 24, height: 24 }} icon="ep:user" />,
        link: '/guest-profile',
    },
];

export const filterReducers = [
    'announcements',
    'appointments',
    'attendance',
    'auth',
    'bookings',
    'churches',
    'contribution',
    'events',
    'help',
    'message',
    'reminders',
    'services',
    'statement',
    'streams',
];
